<svelte:options accessors/>
<script>
    import {createEventDispatcher, onMount} from "svelte";
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import NauiTextarea from "../../../naui/atoms/NauiTextarea.svelte";
    import DesisteSlideover from "../solicitud/DesisteSlideover.svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import NauiSelect from "../../../naui/atoms/NauiSelect.svelte";
    import NauiDatePicker from "../../../naui/atoms/NauiDatePicker.svelte";
    import {getFormatter, hoursOptions} from "../../../utils";
    import NauiSlideOver from "../../../naui/layout/NauiSlideOver.svelte";

    const events = new createEventDispatcher();

    export let data;

    let open = false;
    let openSlideoverDesiste = false;
    let horas = hoursOptions;
    let valorPoliza = 0;
    let formatter = getFormatter();

    $: insurances = getInsurances(data);

    onMount(() => {
        if (data.servicio_transporte) {
            actualizarPoliza(data.servicio_transporte.seguro_transporte);
        }
    });

    function save() {
        events('save', data);
    }

    function approve() {
        events('approve', data);
    }

    function getInsurances(d) {
        if (d && d.insurers && d.servicio_transporte) {
            const insurer = d.insurers.find(i => i.value === d.servicio_transporte.asegurador);
            if (insurer) {
                return insurer.insurances;
            }
        }
        return [];
    }

    function actualizarPoliza(id) {
        const dt = insurances.find(i => i.value === id);
        valorPoliza = dt ? dt.price : 0;
    }
</script>

<div>
    <div class="box-l mt-1">
        <NauiButton on:click={save}
                    caption="GUARDAR"
                    mode="solid"
                    color="accent"
                    className="mr-2"/>
        <NauiButton caption="GENERAR PDF"
                    mode="stroked"
                    color="accent"
                    className="mr-2" on:click={() => {events('pdf')}}/>
        <NauiButton on:click={() => {openSlideoverDesiste = true}}
                    caption="CLIENTE DESISTE"
                    mode="stroked"
                    color="accent"
                    className="mr-2"/>
        <NauiButton on:click={() => {open = !open}}
                    caption="COTIZACIÓN APROBADA"
                    mode="stroked"
                    color="accent"
                    className="mr-2"/>
        {#if !data.has_pdf}
        <div>
            Esta cotización aun no tiene PDF generado
        </div>
        {/if}
    </div>
    <div class="box-l py-15">
        <NauiButton caption="GENERAR PROPUESTA NODRIZA"
                    on:click={() => {events('nodriza')}}
                    mode="solid"
                    color="accent"
                    className="mr-2"/>
        <div class="grid-2 gap-2">
            {#if data.nodriza_link}
            <div class="grid">
                <strong>Link de la propuesta: </strong>
                <div class="propuesta">
                    <a href={data.nodriza_link} target="_blank"> {data.nodriza_link}</a>
                </div>
            </div>
            {/if}
            {#if data.nodriza_lead}
            <div class="grid">
                <strong>Lead para el cliente: </strong>
                <div class="propuesta">
                    <a href={data.nodriza_lead} target="_blank"> {data.nodriza_lead}</a>
                </div>
            </div>
            {/if}
        </div>
    </div>
    <fieldset>
        {#if data.servicio_transporte}
        <legend>SERVICIO DE TRANSPORTE</legend>
        <div class="grid-3 gap-15">
            <NauiInput bind:value={data.servicio_transporte.direccion_origen} label="Dirección de origen"/>
            <NauiInput bind:value={data.servicio_transporte.direccion_destino} label="Dirección de destino"/>
            <NauiInput label="VALOR TRANSPORTE" value={formatter(data.servicio_transporte.total)} isDisabled={true}/>
        </div>
        <div class="grid-4 gap-15 mt-1">
            <NauiSelect bind:value={data.servicio_transporte.asegurador}
                        label="Seguro de transporte"
                        options={data.insurers}/>
            <NauiSelect bind:value={data.servicio_transporte.seguro_transporte}
                        on:change={(ev) => {actualizarPoliza(+ev.target.value)}}
                        label="Valor asegurable"
                        options={insurances}/>
            <NauiInput label="VALOR PÓLIZA"
                       value={formatter(valorPoliza)}
                       isDisabled={true}/>
        </div>
        <hr/>
        {/if}
        <div class="grid-3 gap-15 mt-3">
            <NauiDatePicker bind:value={data.fecha_estimada}
                            label="Fecha estimada y válida hasta"/>
            <NauiSelect label="Hora de inicio"
                        options="{horas}"
                        icon="clock"
                        bind:value={data.hora_inicio}/>
            <div class="box-l sx-1">
                <NauiButton icon="minus-circle" color="accent"
                            on:click={() => {data.numero_dias = Math.max(data.numero_dias - 1, 1)}}/>
                <NauiInput label="Número de días"
                           type="number"
                           bind:value={data.numero_dias}/>
                <NauiButton icon="plus-circle" color="accent"
                            on:click={() => {data.numero_dias += 1}}/>
            </div>
        </div>
    </fieldset>

    <hr>

    {#if data.services.transport}
    <div class="mt-1">
        <h2>Seguro de transporte</h2>
        <NauiCheckbox bind:value={data.servicio_transporte.valor_declarado_seguro_transporte}
                      label="El valor declarado será por toda la carga almacenada en el camión; se debe asegurar por el valor real de los elementos que serán transportados, cada millón asegurado tiene un valor de $5.000, si el seguro excede los 25 millones por favor informarnos para ponerlo en contacto con un asesor"/>
    </div>
    {/if}

    <div class="mt-3">
        <h2>Tener en cuenta que:</h2>
        <NauiCheckbox bind:value={data.tener_en_cuenta.electrodomesticos}
                      label="Electrodomésticos se retiran e instalan"/>
        <NauiCheckbox bind:value={data.tener_en_cuenta.cortinas_lamparas_repisas}
                      label="Cortinas, lámparas decorativas y repisas deben ser retiradas e instaladas por el cliente"/>
        <NauiCheckbox bind:value={data.tener_en_cuenta.no_desarmado_muebles_modulares}
                      label="No hace desarmado de muebles modulares"/>
        <NauiCheckbox bind:value={data.tener_en_cuenta.televisores}
                      label="Los televisores se desconectan y se bajan de su base mas no se instalaran o configuraran en el punto de llegada."/>
        <NauiCheckbox bind:value={data.tener_en_cuenta.cliente_presente}
                      label="Para el empaque, cargue y descargue el cliente debe estar presente y supervisar que el camión quede desocupado."/>
    </div>

    <div class="mt-1">
        <h2>No aplica movimientos por</h2>
        <NauiCheckbox bind:value={data.no_aplica_movimiento.plantas}
                      label="Traslado de plantas y materas"/>
        <NauiCheckbox bind:value={data.no_aplica_movimiento.fachadas}
                      label="Movimientos por fachadas"/>
        <NauiCheckbox bind:value={data.no_aplica_movimiento.fachadas_piso8}
                      label="Movimientos por fachadas cuando supere un piso 8"/>
    </div>

    <div class="mt-3">
        {#if data.services.packaging}
        <NauiTextarea label="Observaciones adicionales embalaje" bind:value={data.observaciones_embalaje}/>
        {/if}
        {#if data.services.packaging || data.services.transport}
        <NauiTextarea label="Observaciones adicionales logística" bind:value={data.observaciones_logistica}/>
        {/if}
        {#if data.services.storage}
        <NauiTextarea label="Observaciones adicionales bodegaje" bind:value={data.observaciones_bodegaje}/>
        {/if}
    </div>

    <DesisteSlideover bind:data={data.informacion_desiste}
                      bind:open={openSlideoverDesiste}
                      on:save={() => {events('clienteDesiste', data);}}/>

    <NauiSlideOver maxWidth="300px" title="APROBAR COTIZACIÓN" bind:open={open}>
        <h3 class="text-c">
            Este servicio será enviado a facturación y a operaciones para continuar con el proceso.
        </h3>
        <h3 class="text-c my-15">
            Recuerde adjuntar el soporte de pago en la pestaña de detalles del servicio y confirmar su programación
        </h3>
        <hr>
        <NauiTextarea label="Observaciones internas adicionales" bind:value={data.observaciones_internas}/>
        <div class="box-c mt-1">
            <NauiButton mode="solid" color="accent" caption="APROBAR COTIZACIÓN" type="submit" on:click={approve}/>
        </div>
    </NauiSlideOver>
</div>

<style>
    .propuesta {
        border: 1px dashed #8d8d8d;
        border-radius: 8px;
        font-size: 12px;
        padding: .6rem;
        margin-top: 4px;

        background-color: rgba(252, 125, 45, 0.01);
        height: 50px;
    }
</style>